var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",staticStyle:{"overflow-y":"auto"},style:({ height: _vm.pageHeight })},[_c('div',{staticClass:"container",attrs:{"id":"capsim-salary-report"}},[(_vm.report)?[_c('BoxPlotChart',{attrs:{"series":_vm.series}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }